<template>
  <div 
    v-if="!isExpired" 
    class="receipt-section">
    <div class="section-header">
      <svg 
        class="section-icon red-icon" 
        width="20" 
        height="20" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14,2 14,8 20,8"/>
      </svg>
      <h3>{{ alreadySubmitted ? 'Receipt Details' : 'Please verify your receipt details' }}</h3>
    </div>
    <div class="receipt-grid">
      <div class="receipt-item">
        <label class="receipt-label">Settlement Date & Time</label>
        <p class="receipt-value">{{ settledDate }}</p>
      </div>
      <div class="receipt-item">
        <label class="receipt-label">Receipt No</label>
        <p class="receipt-value">{{ invoiceNo }}</p>
      </div>
      <div class="receipt-item">
        <label class="receipt-label">Grand Total</label>
        <p class="receipt-value amount">RM {{ grandTotal }}</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
    name: 'ReceiptDetailsSection',
    props: {
        isExpired: {
            type: Boolean,
            required: true,
        },
        alreadySubmitted: {
            type: Boolean,
            required: true,
        },
        settledDate: {
            type: String,
            required: true,
        },
        invoiceNo: {
            type: String,
            required: true,
        },
        grandTotal: {
            type: String,
            required: true,
        },
    },
};
</script>
  
  <style scoped>
.receipt-section {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
}

.section-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #f1f5f9;
    border-bottom: 1px solid #e2e8f0;
}

.section-icon {
    color: #ef5350;
    margin-right: 12px;
    flex-shrink: 0;
}

.section-header h3 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
}

.receipt-grid {
    padding: 24px;
    display: grid;
    gap: 20px;
}

.receipt-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.receipt-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin: 0;
}

.receipt-value {
    font-size: 1rem;
    color: #1e293b;
    margin: 0;
    padding: 8px 0;
}

.receipt-value.amount {
    font-size: 1.25rem;
    font-weight: 700;
    color: #ef5350;
}

@media (max-width: 768px) {
    .section-header {
        padding: 16px 20px;
    }
    .receipt-grid {
        padding: 20px;
        gap: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/e-invoice/portal/components/ReceiptDetailsSection.vue